import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { InteractionType } from "@azure/msal-browser";
import { MsalProvider, MsalAuthenticationTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { client as publicClientApplication } from './utilities/AuthUtils';

import 'bootstrap/dist/css/bootstrap.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const container = document.getElementById('root');
const root = createRoot(container);

publicClientApplication.initialize();

root.render(
    <React.StrictMode>
        <MsalProvider instance={publicClientApplication}>
            <BrowserRouter basename={baseUrl}>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                    <App />
                </MsalAuthenticationTemplate>
                <UnauthenticatedTemplate>
                    <p>Unauthorized</p>
                </UnauthenticatedTemplate>
            </BrowserRouter>
        </ MsalProvider>
    </React.StrictMode>
);
